/* src/app/recalculate-transactions/schedules-presenter/schedules-presenter.component.scss */
body#themeTag :host ::ng-deep .p-toolbar.p-component {
  height: 53.8px !important;
}
/*# sourceMappingURL=schedules-presenter.component.css.map */
